import { DndContext, useDraggable } from '@dnd-kit/core';
import {
  AppBar,
  Avatar,
  Badge,
  Box,
  ClickAwayListener,
  Divider,
  Grid,
  IconButton,
  styled,
  Tab,
  Tabs,
  Toolbar,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import avatar5 from 'assets/avatar-5.png';
import AlarmWindow from 'components/AlarmWindow';
import FlexBox from 'components/flexbox/FlexBox';
import ModernMenuPanel from 'components/menu/ModernMenuPanel';
import WarningModal from 'components/modal/alerts/WarningModal';
import { H2, H3, H5, H6 } from 'components/Typography';
import { AlignLeft, Bell, Search, Settings, X } from 'lucide-react';
import LoginModal from 'pages/login-modal';
import SignupModal from 'pages/signup-modal';
import React, { useEffect, useMemo, useState } from 'react';
import { Menu } from 'react-feather';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import GreySearchBar from './GreySearchBar';

const menus = [
  {
    name: '클래스',
    url: '/naver/jiwongumMain2',
    menus: [
      {
        name: '법인강의',
        url: '/naver/coursemain',
        children: [
          { name: '세무세일즈', url: 'comingsoon' },
          { name: '정책자금', url: 'comingsoon' },
          {
            name: '기업인증',
            url: 'comingsoon',
          },
          { name: '무상지원금', url: 'comingsoon' },
          { name: '서비스설명1', url: 'comingsoon' },
        ],
      },
      {
        name: '기업리포트',
        url: '/naver/report-creator',
        children: [
          { name: '기업검색', url: 'comingsoon' },
          { name: '분석요청', url: 'comingsoon' },
          { name: '서비스설명2', url: 'comingsoon' },
        ],
      },
      {
        name: '정부지원금',
        url: '/naver/main-ai',
        children: [
          { name: '정책자금', url: 'comingsoon' },
          { name: '기업마당', url: '/naver/forumlist' },
          { name: 'K스타트업', url: '/naver/forumlist' },
          {
            name: '소상공인진흥공단',
            url: 'comingsoon',
          },
          { name: '노무지원금', url: 'comingsoon' },
        ],
      },
      {
        name: 'AI서류도우미',
        url: '/naver/wrtn',
        children: [
          { name: '챗 GPT MAX', url: '/naver/wrtn' },
          {
            name: '한글 · 엑셀 양식',
            url: '/naver/community',
          },
          { name: '신보 · 기보', url: 'comingsoon' },
          {
            name: '소상공인진흥공단기보',
            url: 'comingsoon',
          },
          { name: '벤처인증', url: 'comingsoon' },
        ],
      },
      {
        name: '법인이슈',
        url: 'comingsoon',
        children: [
          { name: '세무이슈', url: 'comingsoon' },
          { name: '법적공방', url: 'comingsoon' },
        ],
      },
      {
        name: '경정청구',
        url: 'https://baro-refund.vercel.app',
        children: [],
      },
      {
        name: '크몽숨고',
        url: '/naver/kmong',
        children: [],
      },
      {
        name: '콜미텔미',
        url: '/naver/callmetellme/main-2',
        children: [],
      },
      {
        name: '랜딩페이지',
        url: '/naver/landing-main',
        children: [
          {
            name: '랜딩페이지1',
            url: '/naver/landing-main',
            children: [],
          },
          {
            name: '랜딩페이지2',
            url: '/naver/landing',
            children: [],
          },
          {
            name: '디디',
            url: '/naver/landing-didi',
            children: [],
          },
          {
            name: '외주랜딩',
            url: 'https://landing-tax.vercel.app/',
            children: [],
          },
        ],
      },
      {
        name: 'AI사업계획서',
        url: '/naver/wrtn2',
        children: [],
      },
      {
        name: '강의업로드',
        url: '/naver/course-upload',
        children: [],
      },
    ],
  },
  {
    name: '커뮤니티',
    url: '/naver/community',
    menus: [
      {
        name: '홈',
        url: '/naver/community',
        children: [],
      },
      { name: '자유게시판', url: '/naver/community/category', children: [] },
      {
        name: '독서리뷰',
        url: 'comingsoon',
        children: [
          { name: '독서리뷰', url: 'comingsoon' },
          { name: 'Q&A 및 혜택', url: 'comingsoon' },
        ],
      },
    ],
  },
  {
    name: '업무소통',
    url: '/naver/workschedule',
    menus: [
      {
        name: '거래처관리',
        url: 'comingsoon',
        children: [
          { name: '거래처목록', url: 'comingsoon' },
          { name: '경정청구', url: 'comingsoon' },
          { name: '정책자금 조회', url: 'comingsoon' },
          { name: '스크래핑', url: 'comingsoon' },
          { name: '마케팅 메세지', url: 'comingsoon' },
        ],
      },
      {
        name: '업무진행',
        url: 'comingsoon',
        children: [
          {
            name: '벤처인증',
            url: 'comingsoon',
          },
          { name: '연구소', url: 'comingsoon' },
          {
            name: '정책자금',
            url: 'comingsoon',
          },
          {
            name: '기장유치',
            url: 'comingsoon',
          },
        ],
      },
      {
        name: '업무소통',
        url: 'comingsoon',
        children: [
          {
            name: '다이렉트 메세지',
            url: 'comingsoon',
          },
        ],
      },
      {
        name: '내 메모함',
        url: 'comingsoon',
        children: [],
      },
      {
        name: '기업 DB 목록',
        url: '/dashboard/Excel2',
        children: [],
      },
      {
        name: '벤처 1',
        url: '/naver/survey1',
        children: [],
      },
      {
        name: '벤처 2',
        url: '/naver/survey2',
        children: [],
      },
    ],
  },
  {
    name: 'CRM',
    url: '/naver/crm/customer-list',
    menus: [
      {
        name: '고객 정보',
        url: '/naver/crm/customer-list',
        children: [],
      },
      {
        name: '게시판 생성',
        url: '/naver/crm/create-board',
        children: [],
      },
      {
        name: '신고받은 게시글 & 신고받은 댓글',
        url: '/naver/crm/reported-posts-and-comments',
        children: [],
      },
      {
        name: '댓글 목록',
        url: '/naver/crm/comment-list',
        children: [],
      },
      {
        name: '유튜브 업로드',
        url: '/naver/crm/youtube-upload',
        children: [],
      },
      {
        name: '배너 설정',
        url: '/naver/crm/banner-settings',
        children: [],
      },
    ],
  },
  {
    name: '홈피관리',
    url: '/dashboard/data-table-v2',
    menus: [
      {
        name: '홈피관리',
        url: '/dashboard/data-table-v2',
        children: [
          {
            name: '벤처인증',
            url: '/naver/insurance/survey',
            children: [],
          },
          {
            name: '채팅',
            url: '/naver/insurance/chat',
            children: [],
          },
          {
            name: '대시보드',
            url: '/naver/insurance/dashboard',
            children: [],
          },
          {
            name: '수기 거래 관리',
            url: '/naver/insurance/table',
            children: [],
          },
          {
            name: '엑셀 표 수정',
            url: '/naver/insurance/table-editor',
            children: [],
          },
          {
            name: '견적 요청',
            url: '/naver/insurance/quotation',
            children: [],
          },
          {
            name: '질문답변',
            url: '/naver/insurance/qna',
            children: [],
          },
          {
            name: '자기소개서',
            url: '/naver/insurance/self-introduction',
            children: [],
          },
          {
            name: '예상세금 서비스',
            url: '/naver/insurance/tax-info',
            children: [],
          },
          {
            name: '경정청구',
            url: '/naver/insurance/tax-reassessment',
          },
          {
            name: '메인배너 수정',
            url: '/naver/insurance/banner-editor',
          },
          {
            name: '사용자 관리',
            url: '/naver/insurance/user-management',
          },
          {
            name: '영업 현황',
            url: '/naver/insurance/progress',
          },
          {
            name: '서버 관리',
            url: '/naver/insurance/server-management',
          },
          {
            name: '클래스 메뉴 관리',
            url: '/naver/insurance/menu-editor',
          },
          {
            name: '커뮤 메뉴 관리',
            url: '/naver/insurance/menu-editor',
          },
        ],
      },
      {
        name: '표 관리',
        url: '',
        children: [
          {
            name: '테이블 데이터 편집기',
            url: '/dashboard/table-editor',
          },
          {
            name: '멤버십 표',
            url: '/naver/table-editor/membership-table',
          },
        ],
      },
    ],
  },
  {
    name: '전산관리',
    url: '/naver/insurance/survey',
    menus: [
      {
        name: '전산관리',
        url: '/naver/insurance/survey',
        children: [
          {
            name: '벤처인증',
            url: '/naver/insurance/survey',
            children: [],
          },
          {
            name: '채팅',
            url: '/naver/insurance/chat',
            children: [],
          },
          {
            name: '대시보드',
            url: '/naver/insurance/dashboard',
            children: [],
          },
          {
            name: '수기 거래 관리',
            url: '/naver/insurance/table',
            children: [],
          },
          {
            name: '견적 요청',
            url: '/naver/insurance/quotation',
            children: [],
          },
          {
            name: '질문답변',
            url: '/naver/insurance/qna',
            children: [],
          },
          {
            name: '자기소개서',
            url: '/naver/insurance/self-introduction',
            children: [],
          },
          {
            name: '예상세금 서비스',
            url: '/naver/insurance/tax-info',
            children: [],
          },
          {
            name: '경정청구',
            url: '/naver/insurance/tax-reassessment',
          },
          {
            name: '메인배너 수정',
            url: '/naver/insurance/banner-editor',
          },
          {
            name: '사용자 관리',
            url: '/naver/insurance/user-management',
          },
          {
            name: '영업 현황',
            url: '/naver/insurance/progress',
          },
          {
            name: '서버 관리',
            url: '/naver/insurance/server-management',
          },
        ],
      },
    ],
  },
  {
    name: '마이페이지',
    url: '/naver/community/profile/other',
    menus: [
      {
        name: '마이페이지',
        url: '/naver/community/profile/other',
        children: [
          {
            name: '내 활동',
            url: '/naver/community/profile/other',
            children: [],
          },
          {
            name: '회원정보관리',
            url: '/naver/community/myinfo',
            children: [],
          },
          {
            name: '구매내역',
            url: '/naver/community/payment-history',
            children: [],
          },
          {
            name: '모바일명함',
            url: '/naver/namecard',
            children: [],
          },
          {
            name: '경정청구 분양받기',
            url: '/naver/community/property',
            children: [],
          },
          { title: '로그아웃', url: 'comingsoon' },
        ],
      },
    ],
  },
];

const StyledToolBar = styled(Toolbar)(() => ({
  alignItems: 'center',
  justifyContent: 'space-between',
  '@media (min-width: 0px)': {
    padding: '0rem 1rem',
    minHeight: 'auto',
  },
}));

const PanelContainer = styled(Box)({
  position: 'absolute',
  top: '100%',
  left: 0,
  width: '100%',
  backgroundColor: '#fff',
  paddingTop: '8px',
  paddingBottom: '24px',
  borderRadius: '0px',
  zIndex: 1202,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

const Row = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  maxWidth: '1200px',
  width: '1200px',
});

const Column = styled(Box)(({ theme, isFirst }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  paddingLeft: 16,
  paddingRight: 16,
  paddingTop: 16,
  paddingBottom: 16,
  borderRight: isFirst ? 'none' : '1px solid #E1E1E1',
  background: isFirst ? '#EFF3FF' : '#FFFFFF',
  borderRadius: isFirst ? '10px' : '0px',
}));

const ColumnItem = styled(Box)(({ theme, isFirstColumn }) => ({
  fontSize: 15,
  fontWeight: 400,
  color: theme.palette.primary.dark,
  padding: '8px 16px',
  borderRadius: '10px',
  whiteSpace: 'nowrap',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: isFirstColumn ? '#D3DCFC' : theme.palette.primary.grey700,
  },
}));

const Overlay = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  zIndex: 9,
}));

const ThirdLevelRow = styled(Box)(({ theme }) => ({
  top: '100%',
  left: 0,
  width: '100%',
  backgroundColor: '#fff',
  zIndex: 1200,
  display: 'flex',
  justifyContent: 'center',
  padding: '4px 0 4px 0',
  borderTop: '1px solid #e1e1e1',
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
}));

const ThirdLevelMenuItem = styled(Box)(({ theme }) => ({
  padding: '8px 1rem',
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  borderRadius: '10px',
  fontWeight: 500,
  fontSize: '0.875rem',
  color: theme.palette.text.primary,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    color: theme.palette.primary.darkBlue,
  },
}));

const DashboardHeaderRoot = styled(AppBar)(
  ({
    theme,
    isLaptop,
    hasThirdLevel,
    isCommunityPage,
    isMobile,
    hideSubMenu,
  }) => ({
    zIndex: 1201,
    boxShadow: 'none',
    padding: isLaptop ? '0.5rem 1rem 0rem 1rem' : '0rem 0rem',
    width: '100%',
    backgroundColor: '#ffffff',
    color: theme.palette.text.primary,
    display: 'flex',
    justifyContent: 'center',
    position: isCommunityPage && isMobile ? 'fixed' : 'sticky',
    top: 0,
    height: 'auto',
    minHeight:
      isCommunityPage && isMobile
        ? '42px'
        : hasThirdLevel
        ? isLaptop
          ? hideSubMenu
            ? '40px'
            : '158px'
          : hideSubMenu
          ? '40px'
          : '110px'
        : isLaptop
        ? hideSubMenu
          ? '40px'
          : '66px'
        : hideSubMenu
        ? '40px'
        : '80px',
  })
);

const MobilePanel = React.memo(
  ({
    isClosing,
    selectedTab,
    handleTabChange,
    handleMenuClick,
    handleMobileMenuToggle,
    menus,
    theme,
    navigate,
  }) => {
    return (
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: '#fff',
          zIndex: 1300,
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100% + 2px)',
          overflow: 'hidden',
          animation: isClosing
            ? 'slideOut 0.3s ease-out'
            : 'slideIn 0.3s ease-out',
          '@keyframes slideIn': {
            from: { transform: 'translateX(100%)' },
            to: { transform: 'translateX(0)' },
          },
          '@keyframes slideOut': {
            from: { transform: 'translateX(0)' },
            to: { transform: 'translateX(100%)' },
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            padding: '10px 20px',
            borderBottom: '1px solid #E1E1E1',
          }}
        >
          <Avatar
            src={avatar5}
            alt="profile-photo"
            sx={{ width: 40, height: 40, marginRight: 1 }}
          />
          <H6 fontWeight={600} marginRight={1.5}>
            이한솔
          </H6>
          <Divider orientation="vertical" flexItem sx={{ my: 1, mr: 1.5 }} />
          <H6
            mr={1}
            fontWeight={600}
            color="primary.darkBlue"
            onClick={() => navigate('/naver/community/profile/other')}
          >
            마이페이지
          </H6>
          <H6 fontWeight={600} color="primary.darkBlue">
            내 강의실
          </H6>
          <IconButton
            onClick={handleMobileMenuToggle}
            sx={{ position: 'absolute', top: 10, right: 10 }}
          >
            <X size={24} color={theme.palette.primary.dark} />
          </IconButton>
        </Box>

        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons={false}
            sx={{
              '& .MuiTabs-scroller': {
                overflowX: 'auto !important',
                '&::-webkit-scrollbar': {
                  display: 'none',
                },
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
              },
              '& .MuiTabs-flexContainer': {
                gap: 0,
                '& .MuiTab-root': {
                  marginRight: '-8px',
                },
              },
            }}
            TabIndicatorProps={{
              style: { backgroundColor: theme.palette.primary.darkBlue },
            }}
          >
            {menus.map((menu, index) => (
              <Tab
                key={index}
                label={menu.name}
                sx={{
                  whiteSpace: 'nowrap',
                  color:
                    selectedTab === index
                      ? theme.palette.primary.darkBlue
                      : 'inherit',
                  '&.Mui-selected': {
                    color: theme.palette.primary.darkBlue,
                  },
                  minWidth: 'auto',
                  padding: '12px 16px',
                  fontSize: '0.875rem',
                }}
              />
            ))}
          </Tabs>
        </Box>

        <Box
          sx={{
            flexGrow: 1,
            overflowY: 'auto',
            WebkitOverflowScrolling: 'touch',
            padding: '20px',
            '-webkit-transform': 'translateZ(0)',
            '-webkit-backface-visibility': 'hidden',
          }}
        >
          {menus[selectedTab]?.menus.map((subMenu, subIndex) => (
            <Box key={subIndex} mb={2}>
              <FlexBox mb={1} alignItems="center">
                <Box
                  mr={1}
                  sx={{
                    width: '6px',
                    height: '6px',
                    backgroundColor: theme.palette.primary.darkBlue,
                    borderRadius: '50%',
                  }}
                />
                <H6
                  fontWeight={500}
                  onClick={() => handleMenuClick(subMenu.url)}
                  sx={{ cursor: 'pointer' }}
                >
                  {subMenu.name}
                </H6>
              </FlexBox>
              <Grid container spacing={1}>
                {subMenu.children.map((child, childIndex) => (
                  <Grid item xs={6} key={childIndex}>
                    <Box
                      component="span"
                      onClick={() => handleMenuClick(child.url)}
                      sx={{
                        color: theme.palette.text.primary,
                        textDecoration: 'none',
                        fontSize: '0.9rem',
                        cursor: 'pointer',
                      }}
                    >
                      {child.name}
                    </Box>
                  </Grid>
                ))}
              </Grid>
              {subIndex < menus[selectedTab]?.menus.length - 1 && (
                <Divider sx={{ my: 3 }} />
              )}
            </Box>
          ))}
        </Box>

        <Box
          sx={{
            backgroundColor: theme.palette.primary.darkBlue,
            padding: '15px 20px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          {['이용내역', '고객센터', '공지사항'].map((item, index) => (
            <React.Fragment key={index}>
              <Box
                component="span"
                sx={{
                  color: '#fff',
                  fontSize: '0.9rem',
                  cursor: 'pointer',
                }}
              >
                {item}
              </Box>
              {index < 2 && (
                <Divider
                  orientation="vertical"
                  flexItem
                  sx={{
                    backgroundColor: 'rgba(255, 255, 255, 0.3)',
                    height: '1rem',
                    mx: 1,
                    mt: 0.5,
                  }}
                />
              )}
            </React.Fragment>
          ))}
        </Box>
      </Box>
    );
  }
);

const DashboardHeader = props => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isLaptop = useMediaQuery(theme.breakpoints.down('lg'));
  const navigate = useNavigate();

  const [showSignupModal, setShowSignupModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [openSearchBar, setSearchBar] = useState(false);

  const [notificationWindowOpen, setNotificationWindowOpen] = useState(false);

  const handleNotificationClick = () => {
    setNotificationWindowOpen(!notificationWindowOpen);
  };

  const { setNodeRef, listeners, transform } = useDraggable({
    id: 'draggable',
  });

  const location = useLocation();

  const [defaultMainMenu, setDefaultMainMenu] = useState(menus[0]);

  const hideSubMenu = useMemo(() => {
    const result =
      location.pathname.includes('landing-didi') ||
      location.pathname.includes('main-ai');

    return result;
  }, [location.pathname]);

  const getCurrentMainMenu = () => {
    const currentMenu = menus.find(
      menu =>
        location.pathname.startsWith(menu.url) ||
        menu.menus.some(subMenu => location.pathname.startsWith(subMenu.url))
    );
    return currentMenu || defaultMainMenu;
  };

  const currentMainMenu = getCurrentMainMenu();

  const [notificationCount, setNotificationCount] = useState(5);

  const [hoveredMainMenu, setHoveredMainMenu] = useState(null);
  const [hoveredSubMenu, setHoveredSubMenu] = useState(null);

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);
  const [warningModalOpen, setWarningModalOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);

  const [isClosing, setIsClosing] = useState(false);

  const [showFullMenu, setShowFullMenu] = useState(false);
  const [currentSecondLevelMenu, setCurrentSecondLevelMenu] = useState(null);

  useEffect(() => {
    const currentMainMenu = getCurrentMainMenu();
    if (currentMainMenu) {
      const matchingSecondLevelMenu = currentMainMenu.menus.find(subMenu =>
        location.pathname.startsWith(subMenu.url)
      );
      setCurrentSecondLevelMenu(matchingSecondLevelMenu);
    } else {
      setCurrentSecondLevelMenu(null);
    }
  }, [location]);

  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    }

    return () => {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
    };
  }, [mobileMenuOpen]);

  useEffect(() => {
    if (!mobileMenuOpen) {
      // Only update tab when mobile menu is closed
      const currentIndex = getCurrentMenuIndex();
      setSelectedTab(currentIndex);
    }
  }, [location, mobileMenuOpen]);

  const getCurrentMenuIndex = () => {
    const index = menus.findIndex(menu =>
      location.pathname.startsWith(menu.url)
    );
    return index !== -1 ? index : 0; // Return 0 (클래스) if no match is found
  };

  const isMenuActive = menuUrl => {
    // Skip check for external URLs and coming soon pages
    if (menuUrl === 'comingsoon' || menuUrl.startsWith('http')) {
      return false;
    }

    // For exact match, compare the paths directly
    const menuPath = menuUrl.split('?')[0].replace(/\/$/, ''); // Remove trailing slash and query parameters
    const currentPath = location.pathname.split('?')[0].replace(/\/$/, '');

    return menuPath === currentPath;
  };

  // Function to check if a parent menu should be active (for underline)
  // This should return true if we're on the parent page OR any of its child pages
  const isParentMenuActive = (parentUrl, childrenUrls = []) => {
    // Skip check for external URLs and coming soon pages
    if (parentUrl === 'comingsoon' || parentUrl.startsWith('http')) {
      return false;
    }

    const parentPath = parentUrl.split('?')[0].replace(/\/$/, '');
    const currentPath = location.pathname.split('?')[0].replace(/\/$/, '');

    // Check if current path exactly matches parent path
    if (parentPath === currentPath) {
      return true;
    }

    // Check if current path matches any of the children URLs
    return childrenUrls.some(childUrl => {
      if (childUrl === 'comingsoon' || childUrl.startsWith('http')) {
        return false;
      }
      const childPath = childUrl.split('?')[0].replace(/\/$/, '');
      return childPath === currentPath;
    });
  };

  const handleMobileMenuToggle = () => {
    // setMobileMenuOpen(!mobileMenuOpen);

    if (mobileMenuOpen) {
      setIsClosing(true);
      setTimeout(() => {
        setMobileMenuOpen(false);
        setIsClosing(false);
      }, 300);
    } else {
      setMobileMenuOpen(true);
    }
  };

  const handleTabChange = (event, newValue) => {
    event.stopPropagation();
    event.preventDefault();
    setSelectedTab(newValue);
    // Ensure mobile menu stays open
    setIsClosing(false);
    setMobileMenuOpen(true);
  };

  const handleMenuClick = url => {
    setMobileMenuOpen(false);
    if (url === 'comingsoon') {
      setWarningModalOpen(true);
    } else if (url.startsWith('http')) {
      // Open external links in a new tab/window
      window.open(url, '_blank', 'noopener,noreferrer');
    } else {
      navigate(url);
    }
  };

  const handleMobileSearchToggle = () => {
    setMobileSearchOpen(!mobileSearchOpen);
  };

  const isCommunityPage = location.pathname === '/naver/community';
  const isCommunityDetailPage = location.pathname === '/naver/community/detail';
  const isCommunityEditorPage = location.pathname === '/naver/community/editor';

  if (
    (isCommunityDetailPage && isMobile) ||
    (isCommunityPage && isMobile) ||
    (isCommunityEditorPage && isMobile)
  ) {
    return null;
  }

  const MobileSecondRow = styled(Box)(({ isMobile, isCommunityPage }) => ({
    overflowX: 'auto',
    whiteSpace: 'nowrap',
    WebkitOverflowScrolling: 'touch',
    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
    display: isMobile && isCommunityPage ? 'none' : 'flex',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    padding: '0rem 1rem',
  }));

  const hasThirdLevel =
    currentSecondLevelMenu &&
    currentSecondLevelMenu.children &&
    currentSecondLevelMenu.children.length > 0;

  return (
    <>
      {showFullMenu && !isMobile && <Overlay />}
      <DashboardHeaderRoot
        key={`header-${hideSubMenu}`}
        hasThirdLevel={hasThirdLevel}
        isCommunityPage={isCommunityPage}
        isMobile={isMobile}
        hideSubMenu={hideSubMenu}
      >
        <SignupModal
          open={showSignupModal}
          setShowSignupModal={setShowSignupModal}
        />
        <LoginModal
          open={showLoginModal}
          setShowLoginModal={setShowLoginModal}
        />

        {isLaptop && (
          <>
            <StyledToolBar>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  paddingBottom: hideSubMenu ? '2px' : '0px',
                }}
              >
                <NavLink to={`/naver/jiwongumMain2`}>
                  <H2
                    sx={{ fontWeight: 700, color: theme.palette.primary.dark }}
                  >
                    슈가클라우드
                  </H2>
                </NavLink>
              </Box>

              <ClickAwayListener onClickAway={() => setSearchBar(false)}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  {!hideSubMenu && (
                    <>
                      <IconButton
                        sx={{
                          height: 40,
                          width: 40,
                        }}
                        onClick={handleMobileSearchToggle}
                      >
                        <Search size={23} color={theme.palette.primary.dark} />
                      </IconButton>

                      <Box sx={{ position: 'relative' }}>
                        <IconButton
                          sx={{
                            height: 40,
                            width: 40,
                          }}
                          onClick={handleNotificationClick}
                        >
                          <Badge
                            badgeContent={notificationCount}
                            color="error"
                            sx={{
                              '& .MuiBadge-badge': {
                                right: 4,
                                top: 3,
                                border: `2px solid ${theme.palette.background.paper}`,
                                padding: '0px 3px 2px 3px',
                              },
                            }}
                          >
                            <Bell
                              size={23}
                              color={theme.palette.primary.dark}
                            />
                          </Badge>
                        </IconButton>

                        {notificationWindowOpen && (
                          <AlarmWindow
                            onClose={() => setNotificationWindowOpen(false)}
                          />
                        )}
                      </Box>
                    </>
                  )}

                  <IconButton
                    sx={{
                      height: 40,
                      width: 40,
                      paddingBottom: hideSubMenu ? '6px' : '0px',
                    }}
                    onClick={handleMobileMenuToggle}
                  >
                    <AlignLeft size={23} color={theme.palette.primary.dark} />
                  </IconButton>
                </Box>
              </ClickAwayListener>
            </StyledToolBar>

            {!hideSubMenu && (
              <MobileSecondRow
                isMobile={isMobile}
                isCommunityPage={isCommunityPage}
              >
                {currentMainMenu?.menus.map((subMenu, index) => (
                  <Box
                    key={index}
                    component="span"
                    onClick={() => handleMenuClick(subMenu.url)}
                    sx={{
                      display: 'inline-block',
                      padding: '8px 18px 10px 0px',
                      color: isParentMenuActive(
                        subMenu.url,
                        subMenu.children?.map(child => child.url) || []
                      )
                        ? theme.palette.primary.darkBlue
                        : theme.palette.text.primary,
                      fontWeight: 500,
                      fontSize: '0.875rem',
                      cursor: 'pointer',
                      position: 'relative',
                      '&:hover': {
                        color: theme.palette.primary.darkBlue,
                      },
                      '&::after': isParentMenuActive(
                        subMenu.url,
                        subMenu.children?.map(child => child.url) || []
                      )
                        ? {
                            content: '""',
                            position: 'absolute',
                            bottom: 0,
                            left: 0,
                            right: 18, // Adjust this value to match the right padding
                            height: '2px',
                            backgroundColor: theme.palette.primary.darkBlue,
                          }
                        : {},
                    }}
                  >
                    {subMenu.name}
                  </Box>
                ))}
              </MobileSecondRow>
            )}

            {mobileSearchOpen && (
              <Box
                sx={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: '#fff',
                  zIndex: 1300,
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '16px',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '16px',
                  }}
                >
                  <H5>검색</H5>
                  <IconButton onClick={handleMobileSearchToggle}>
                    <X size={24} color={theme.palette.primary.dark} />
                  </IconButton>
                </Box>
                <GreySearchBar isMobile={isLaptop} />
              </Box>
            )}
          </>
        )}

        {showFullMenu && !isMobile && (
          // 예전 패널 디자인

          // <PanelContainer
          //   onMouseEnter={() => setShowFullMenu(true)}
          //   onMouseLeave={() => {
          //     setShowFullMenu(false);
          //     setHoveredMainMenu(null);
          //     setHoveredSubMenu(null);
          //   }}
          // >
          //   <Row>
          //     {menus.map((menu, menuIndex) => (
          //       <Column key={menuIndex} isFirst={menuIndex === 0}>
          //         <ColumnItem isFirstColumn={menuIndex === 0}>
          //           <H6 sx={{ fontWeight: 600 }}>{menu.name}</H6>
          //           <ChevronRight
          //             size={20}
          //             color={theme.palette.primary.grey400}
          //           />
          //         </ColumnItem>
          //         {menu.menus.map((subMenu, subIndex) => (
          //           <ColumnItem key={subIndex} isFirstColumn={menuIndex === 0}>
          //             <Box
          //               component="span"
          //               onClick={() => handleMenuClick(subMenu.url)}
          //               sx={{
          //                 color: "inherit",
          //                 textDecoration: "none",
          //                 width: "100%",
          //                 cursor: "pointer",
          //               }}
          //             >
          //               {subMenu.name}
          //             </Box>
          //           </ColumnItem>
          //         ))}
          //       </Column>
          //     ))}
          //   </Row>
          // </PanelContainer>

          <ModernMenuPanel
            menus={menus}
            isMenuActive={isMenuActive}
            handleMenuClick={handleMenuClick}
            onMouseEnter={() => setShowFullMenu(true)}
            onMouseLeave={() => {
              setShowFullMenu(false);
              setHoveredMainMenu(null);
              setHoveredSubMenu(null);
            }}
          />
        )}

        <DndContext>
          <FlexBox
            sx={{
              flexDirection: 'column',
              alignItems: 'center',
              borderBottom: '1px solid #E1E1E1',
            }}
            onMouseLeave={() => {
              setHoveredMainMenu(null);
              setHoveredSubMenu(null);
              setShowFullMenu(false);
            }}
          >
            {/* First row */}
            <StyledToolBar
              ref={setNodeRef}
              {...listeners}
              style={{
                width: '100%',
                maxWidth: '1200px',
                overflow: 'visible',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
                display: 'flex',
                flexDirection: 'row',
                transform: transform
                  ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
                  : undefined,
                WebkitOverflowScrolling: 'touch',
              }}
            >
              {!isLaptop && (
                <>
                  <Box
                    sx={{
                      display: 'flex',
                      width: '220px',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <NavLink to={`/naver/jiwongummain2`}>
                      <H3
                        mr={1}
                        sx={{
                          fontWeight: 700,
                          color: theme.palette.primary.dark,
                        }}
                      >
                        슈가클라우드
                      </H3>
                    </NavLink>

                    {menus.map(menu => (
                      <H5
                        key={menu.name}
                        sx={{
                          whiteSpace: 'nowrap',
                          fontWeight: 700,
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        {(menu.name === '홈피관리' ||
                          menu.name === '전산관리') && (
                          <Settings
                            size={18}
                            style={{ marginLeft: '16px' }}
                            color={
                              isMenuActive(menu.url)
                                ? theme.palette.primary.darkBlue
                                : theme.palette.primary.dark
                            }
                          />
                        )}
                        <Box
                          component="span"
                          onClick={() => handleMenuClick(menu.url)}
                          sx={{
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            color: isMenuActive(menu.url)
                              ? theme.palette.primary.darkBlue
                              : 'inherit',
                            marginLeft:
                              menu.name === '홈피관리' ||
                              menu.name === '전산관리'
                                ? '4px'
                                : '20px',
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          {menu.name}
                        </Box>
                      </H5>
                    ))}
                  </Box>

                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <Box
                      ml={1}
                      mr={2}
                      my={1}
                      sx={{
                        width: '100%',
                        minWidth: '400px',
                        padding: '0 0 0 0',
                        position: 'relative',
                        zIndex: 1202,
                      }}
                    >
                      <GreySearchBar isHeader={true} isMobile={isMobile} />
                    </Box>

                    <Box sx={{ position: 'relative' }}>
                      <IconButton
                        sx={{
                          borderRadius: '10px',
                          border: '1px solid #E1E1E1',
                          height: 40,
                          width: 40,
                        }}
                        onClick={handleNotificationClick}
                      >
                        <Badge
                          badgeContent={notificationCount}
                          color="error"
                          sx={{
                            '& .MuiBadge-badge': {
                              right: 4,
                              top: 3,
                              border: `2px solid ${theme.palette.background.paper}`,
                              padding: '0px 3px 2px 3px',
                            },
                          }}
                        >
                          <Bell size={23} color={theme.palette.primary.dark} />
                        </Badge>
                      </IconButton>

                      {notificationWindowOpen && (
                        <AlarmWindow
                          onClose={() => setNotificationWindowOpen(false)}
                        />
                      )}
                    </Box>

                    {/* <IconButton
                      sx={{
                        marginLeft: "10px",
                        borderRadius: "10px",
                        border: "1px solid #E1E1E1",
                        height: 40,
                        padding: "0 10px",
                      }}
                    >
                      <FlexBox alignItems="center">
                        <Avatar
                          src={avatar5}
                          alt={"profile-photo"}
                          sx={{ mr: 0.5, width: 30, height: 30 }}
                        />
                        <H6 fontWeight={600}>
                          <NavLink
                            to={`/naver/community/profile/other`}
                            style={{
                              cursor: "pointer",
                              whiteSpace: "nowrap",
                              color: "inherit",
                              marginLeft: "4px",
                            }}
                          >
                            마이페이지
                          </NavLink>
                        </H6>
                      </FlexBox>
                    </IconButton> */}
                  </Box>
                </>
              )}
            </StyledToolBar>

            {/* Second row */}
            <StyledToolBar
              ref={setNodeRef}
              {...listeners}
              style={{
                width: '100%',
                maxWidth: '1200px',
                overflow: 'visible',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
                display: 'flex',
                flexDirection: 'row',
                transform: transform
                  ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
                  : undefined,
                WebkitOverflowScrolling: 'touch',
              }}
            >
              {!isLaptop && (
                <Box
                  sx={{
                    display: 'flex',
                    width: '100%',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                  }}
                >
                  <FlexBox
                    pt={1}
                    pb={2}
                    alignItems="center"
                    onMouseEnter={() => {
                      setShowFullMenu(true);
                      setHoveredMainMenu('전체메뉴');
                    }}
                    sx={{ position: 'relative', marginRight: '20px' }}
                  >
                    <Menu
                      size={19}
                      color={
                        hoveredMainMenu === '전체메뉴'
                          ? theme.palette.primary.darkBlue
                          : theme.palette.primary.dark
                      }
                    />
                    <H6 fontWeight={600}>
                      <NavLink
                        to={`/naver/forumlist`}
                        style={{
                          cursor: 'pointer',
                          whiteSpace: 'nowrap',
                          color:
                            hoveredMainMenu === '전체메뉴'
                              ? theme.palette.primary.darkBlue
                              : 'inherit',
                          marginLeft: '4px',
                        }}
                      >
                        전체메뉴
                      </NavLink>
                    </H6>
                    {hoveredMainMenu === '전체메뉴' && (
                      <Box
                        sx={{
                          position: 'absolute',
                          bottom: 0,
                          left: 0,
                          right: 0,
                          height: 2,
                          backgroundColor: theme.palette.primary.darkBlue,
                        }}
                      />
                    )}
                  </FlexBox>

                  {currentMainMenu.menus.map((subMenu, index) => (
                    <H6
                      key={index}
                      pt={1}
                      pb={2}
                      sx={{
                        whiteSpace: 'nowrap',
                        fontWeight: 500,
                        marginRight: '20px',
                        cursor: 'pointer',
                        position: 'relative',
                        color: isParentMenuActive(
                          subMenu.url,
                          subMenu.children?.map(child => child.url) || []
                        )
                          ? theme.palette.primary.darkBlue
                          : 'inherit',
                        '&:hover': {
                          color: theme.palette.primary.darkBlue,
                        },
                      }}
                      onMouseEnter={() => {
                        setHoveredSubMenu(subMenu);
                        setShowFullMenu(false);
                      }}
                      onClick={() => handleMenuClick(subMenu.url)}
                    >
                      {subMenu.name}
                      {(hoveredSubMenu === subMenu ||
                        isParentMenuActive(
                          subMenu.url,
                          subMenu.children?.map(child => child.url) || []
                        )) && (
                        <Box
                          sx={{
                            position: 'absolute',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            height: 2,
                            backgroundColor: theme.palette.primary.darkBlue,
                          }}
                        />
                      )}
                    </H6>
                  ))}
                </Box>
              )}
            </StyledToolBar>

            {currentSecondLevelMenu &&
              currentSecondLevelMenu.children &&
              currentSecondLevelMenu.children.length > 0 &&
              !hideSubMenu && (
                <ThirdLevelRow>
                  <Box
                    sx={{
                      display: 'flex',
                      maxWidth: '1200px',
                      width: '100%',
                    }}
                  >
                    {currentSecondLevelMenu.children.map((child, index) => (
                      <ThirdLevelMenuItem
                        key={index}
                        onClick={() => handleMenuClick(child.url)}
                        sx={{
                          color: isMenuActive(child.url)
                            ? theme.palette.primary.darkBlue
                            : theme.palette.text.primary,
                          position: 'relative',
                        }}
                      >
                        {child.name}
                      </ThirdLevelMenuItem>
                    ))}
                  </Box>
                </ThirdLevelRow>
              )}
          </FlexBox>
        </DndContext>
      </DashboardHeaderRoot>

      {mobileMenuOpen && (
        <MobilePanel
          isClosing={isClosing}
          selectedTab={selectedTab}
          handleTabChange={handleTabChange}
          handleMenuClick={handleMenuClick}
          handleMobileMenuToggle={handleMobileMenuToggle}
          menus={menus}
          theme={theme}
          navigate={navigate}
        />
      )}

      <WarningModal
        showModal={warningModalOpen}
        setShowModal={setWarningModalOpen}
        title="경고"
        messages={['아직 준비중인 서비스입니다.']}
      />
    </>
  );
};

export default DashboardHeader;
